<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  areaName?: string
  shortName?: string
  stageName?: string
}

const props = defineProps<Props>()

// computed
const competitionPath = computed(() =>
  [props.areaName, props.shortName, props.stageName]
    .filter((item) => !!item)
    .join(' - '),
)
</script>

<template>
  <div class="text-neutral-dark-3 truncate text-xs">
    {{ competitionPath }}
  </div>
</template>
